import { render, staticRenderFns } from "./AssignLocationForm.vue?vue&type=template&id=585cd9a7&scoped=true&"
import script from "./AssignLocationForm.vue?vue&type=script&lang=js&"
export * from "./AssignLocationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585cd9a7",
  null
  
)

export default component.exports